import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { Content } from 'core/layouts';
import { observer } from "mobx-react";
import { BaasicButton } from 'core/components';
import { handleKeyDown, handlePaste } from 'core/utils';

function PickTicketDetailNewFlowItemDetailsModalTemplate({ pickTicketDetailNewFlowItemDetailsModalStore, t }) {
    const {
        loaderStore: { loading },
        items,
        pickTicketDetail,
        isSendSeparately,
        saveChanges,
        disabled,
        modalParams,
        warningMessage,
        showWarningMessage
    } = pickTicketDetailNewFlowItemDetailsModalStore;
    return (
        <div style={{ minHeight: 80 }}>
            <Content loading={loading}>
                <div className="modal__header">
                    <h3 className='modal__header__title'>Item details</h3>
                </div>
                <div className="modal__body">
                    <div className="u-mar--bottom--sml">
                        <h3 className='modal__header__title u-mar--bottom--sml'>
                            {pickTicketDetail.itemId} {pickTicketDetail.itemName}
                        </h3>
                    </div>
                    {
                        items &&
                        <React.Fragment>
                            <div className="u-mar--bottom--sml u-flex--default u-flex--gap--2">
                                <p className="u-mar--right--tny">Sales Order Qty: <b>{items.reduce((acc, item) => acc + (item.orderQuantity || 0), 0)}</b></p>
                                <div className="card--tertiary__header__divider"></div>
                                <p className="u-mar--x--tny">SS Qty: <b>{items.reduce((acc, item) => acc + (item.sendSeparatelyQty || 0), 0)}</b></p>
                            </div>
                            {showWarningMessage && warningMessage &&
                                <div className="message message--warning message--med u-mar--top--xsml">
                                    <p>{warningMessage}</p>
                                </div>}
                            <FacilityOrderTemplateItemsTable
                                pickTicketDetailNewFlowItemDetailsModalStore={pickTicketDetailNewFlowItemDetailsModalStore}
                                items={items}
                            />
                        </React.Fragment>
                    }
                </div>
                <div className='modal__footer is-right'>
                    {isSendSeparately &&
                        <React.Fragment>
                            <BaasicButton
                                className='btn btn--med btn--light'
                                label={t('EDIT_FORM_LAYOUT.CANCEL')}
                                disabled={disabled}
                                onClick={() => modalParams.close()}
                            />
                            <BaasicButton
                                className="btn btn--med btn--primary"
                                disabled={disabled}
                                label={"Save changes"}
                                onClick={() => saveChanges()}
                            />
                        </React.Fragment>}
                </div>
            </Content>
        </div>
    )
}

PickTicketDetailNewFlowItemDetailsModalTemplate.propTypes = {
    pickTicketDetailNewFlowItemDetailsModalStore: PropTypes.object,
    t: PropTypes.any
};

const FacilityOrderTemplateItemsTable = observer(({ pickTicketDetailNewFlowItemDetailsModalStore, items }) => {
    const {
        isSendSeparately,
        disabled,
        editSendSeparatelyQuantity,
        setSendSeparately
    } = pickTicketDetailNewFlowItemDetailsModalStore;

    return (
        <div className="u-mar--top--sml">
            <table className="table--preview">
                <thead>
                    <tr>
                        <th width="30%" className="type--left">Patient Name</th>
                        <th width="20%" className="type--left">Eligibility Status</th>
                        <th width="20%" className="type--left">Clinical Status</th>
                        <th width="15%" className="type--left">SO QTY</th>
                        <th width="15%" className="type--left table-col-input">
                            <div className='u-flex--default u-flex--space-between'>
                                SS QTY 
                                <BaasicButton
                                    className="btn btn--icon btn--icon--sml-med"
                                    icon="u-icon u-icon--sml u-icon--edit-alt table__icon--edit"
                                    label="Update SS Qty"
                                    onlyIcon={true}
                                    onClick={() => setSendSeparately(true)}
                            ></BaasicButton>
                        </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => {
                        return (
                            <tr key={item.id}>
                                <td>{item.facilityOrderTemplate && item.facilityOrderTemplate.patient.fullName}</td>
                                <td>{item.facilityOrderPatient && item.facilityOrderPatient.eligibilityStatus && item.facilityOrderPatient.eligibilityStatus.name}</td>
                                <td>{item.facilityOrderTemplate && item.facilityOrderTemplate.clinicalStatus && item.facilityOrderTemplate.clinicalStatus.name}</td>
                                <td>{item.orderQuantity}</td>
                                <td className="type--left">
                                    <input
                                        className="input input--sml"
                                        onKeyDown={handleKeyDown}
                                        onPaste={handlePaste}
                                        disabled={!isSendSeparately || disabled}
                                        onClick={(e) => e.target.select()}
                                        onChange={(e) => editSendSeparatelyQuantity(index, e.target.value)}
                                        value={item.sendSeparatelyQty}
                                        type="number"
                                        min="0"
                                        max="999.99"
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
});

FacilityOrderTemplateItemsTable.propTypes = {
    pickTicketDetailNewFlowItemDetailsModalStore: PropTypes.object,
    items: PropTypes.func
};

export default defaultTemplate(PickTicketDetailNewFlowItemDetailsModalTemplate);
